module.exports = __webpack_public_path__ + "media/message.3425aa6d.mp3";